var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeatIcon = function SvgRepeatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 13.5H1.5V12a6.75 6.75 0 0 1 6.75-6.75h11.378l-2.43-2.43 1.057-1.065L22.5 6l-4.245 4.245-1.057-1.065 2.43-2.43H8.25A5.25 5.25 0 0 0 3 12zm18-3V12c0 2.9-2.35 5.25-5.25 5.25H4.372l2.43-2.43-1.057-1.065L1.5 18l4.245 4.245 1.058-1.065-2.43-2.43H15.75A6.75 6.75 0 0 0 22.5 12v-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgRepeatIcon;